import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Handles the Emergent OAuth redirect: {origin}/portal#session_id=xxx
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setSession(data.token, data.user);
        // Clean the hash and land on the portal
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/portal", { replace: true });
      } catch {
        setError("Sign-in failed. Please try again.");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    })();
  }, [navigate, setSession]);

  return (
    <div className="dark min-h-screen bg-background text-foreground flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      {error ? (
        <p className="font-mono text-sm text-destructive">{error}</p>
      ) : (
        <>
          <Loader2 className="animate-spin text-primary" size={28} />
          <p className="font-mono text-xs uppercase tracking-widest text-muted-foreground">Signing you in…</p>
        </>
      )}
    </div>
  );
}
